import React from 'react';
import CSPContainer from '@src/containers/CSPManage';

const CSP = () => <CSPContainer />;

export default CSP;
